// extracted by mini-css-extract-plugin
module.exports = {"label":"AddReportTypeForm_label__vs6hf","buttons":"AddReportTypeForm_buttons__pToER"};